import { Injectable } from '@angular/core';
import { PartialStateUpdater, patchState, signalState } from '@ngrx/signals';
import { FileDocumentTypeUi } from 'src/app/shared/models/files.model';

interface State {
  fileDocumentTypes: FileDocumentTypeUi[];
}

const defaultState: State = {
  fileDocumentTypes: [],
};

@Injectable({
  providedIn: 'root',
})
export class GlobalState {
  private readonly createPackageGlobalState = signalState<State>(defaultState);

  public readonly fileDocumentTypes =
    this.createPackageGlobalState.fileDocumentTypes;

  setFileDocumentTypes(fileDocumentTypes: FileDocumentTypeUi[]): void {
    patchState(
      this.createPackageGlobalState,
      this.fileDocumentTypesSetter(fileDocumentTypes)
    );
  }

  private fileDocumentTypesSetter(
    fileDocumentTypes: FileDocumentTypeUi[]
  ): PartialStateUpdater<{ fileDocumentTypes: State['fileDocumentTypes'] }> {
    return (state: Partial<State>) => {
      return {
        ...state,
        fileDocumentTypes: structuredClone(fileDocumentTypes),
      };
    };
  }
}
